/**
 * @file Registration of WebUI tests
 * @copyright Digital Living Software Corp. 2014-2015
 */

/* global angular */

(function () {
    'use strict';

    angular.module('pipWebuiTests', [
        'pipTest.DataSet',
        'pipTest.Account',
        'pipTest.Entity',
        'pipTest.UserParty',
        'pipTest.General',
        'pipTest.Content'


    ]);

})();


